import { defineStore, mapActions } from "pinia";
import { useAxiosStore } from "js/stores/axiosStore.js";

export const useTripStore = defineStore("tripStore", {
    state: () => {
        return {
            dirty: true,
            query: {},
            list: [],
            index: {},
        };
    },
    actions: {
        populate(items) {
            this.list = items;
            this.dirty = false;
            this.buildIndexes();
        },

        async fetchTrips(params) {
            return this.fetch("/api/trips", params);
        },

        add(trip) {
            this.list.unshift(trip);
            this.buildIndexes();

            this.checkQueryForDirty();
        },

        update(tripData) {
            const id = tripData.id;
            const trip = this.find(id);

            if (trip !== null) {
                Object.keys(trip).forEach((key) => {
                    trip[key] = tripData[key];
                });
            } else {
                this.add(tripData);
            }
        },

        updateQuery(key, value) {
            if (value === null && this.query[key]) {
                delete this.query[key];
            } else {
                this.query[key] = value;
            }
        },

        async refreshLocations(id) {
            if (this.index[id] === undefined) {
                return undefined;
            }
            const locations = await this.fetch(`/api/trips/${id}/locations`);
            this.list[this.index[id]].locations = locations;

            return locations;
        },

        replaceLocation(id, locationId, newLocation) {
            let trip = this.find(id);
            trip.locations.forEach((location) => {
                if (location.id !== locationId) {
                    return;
                }
                Object.keys(location).forEach((key) => {
                    location[key] = newLocation[key];
                });
            });
        },

        hasDirtyLocations(id) {
            let trip = this.find(id);
            if (trip.locations === undefined) {
                return true;
            }
            if (trip.locations.length && trip.locations[0].is_compact) {
                return true;
            }
            return false;
        },

        find(id) {
            const i = this.index[id];
            if (i === undefined) {
                return null;
            }
            return this.list[i];
        },

        remove(id) {
            if (this.index[id] === undefined) {
                return;
            }
            this.list = this.list.filter((trip) => trip.id !== id);
            this.buildIndexes();
        },

        // build a dictionary of relations between a trip id and trip's position
        // in list.items so that finding a trip by id is faster
        buildIndexes() {
            this.index = {};
            this.list.forEach((trip, i) => {
                this.index[trip.id] = i;
            });
        },

        checkQueryForDirty() {
            // Set dirty if query is not empty - the store will have to refresh
            let hasQuery = !!Object.keys(this.query).length;
            if (hasQuery) {
                this.dirty = true;
                this.query = {};
            }
        },

        setDirty() {
            this.dirty = true;
        },

        ...mapActions(useAxiosStore, ["fetch", "create", "edit", "delete"]),
    },
});
